import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class Feedback1Component implements OnInit {

  @Input() name: any;
  @Input() cssMybutton: any;
  @Input() cssChat: any;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.cssChat = 'width: 300px';
  }

  openDialog(){
    this.dialog.open(ChatComponent, {
      width: '50%',
      height: 'auto'
    });
  }
}

@Component({
  selector: 'app-chat-component',
  templateUrl: 'chat-component.html',
})
export class ChatComponent {}

